import { render, staticRenderFns } from "./SendReportToLabView.vue?vue&type=template&id=33180009&scoped=true&"
import script from "./SendReportToLabView.vue?vue&type=script&lang=ts&"
export * from "./SendReportToLabView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33180009",
  null
  
)

export default component.exports